export default "__VITE_ASSET__8KuxfWPv__"